import { Icon } from '@atom/mui';
import { LocationOffIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';

import classes from './list.module.css';

const styles = {
  icon: { color: colors.neutral.gray },
};

type NoItemsPaneProps = {
  text: string;
  subtext?: string | null;
};

const NoItemsPane = ({ text, subtext }: NoItemsPaneProps) => (
  <div className={classes.noItemsContainer}>
    <Icon
      className={classes.noItemsIcon}
      sx={styles.icon}
      icon={LocationOffIcon}
    />
    <div className={classes.noItemsText}>{text}</div>
    {subtext && <div className={classes.noItemsSubtext}>{subtext}</div>}
  </div>
);

export default NoItemsPane;
